module.exports = __webpack_public_path__ + "img/11087942_L.f0755e68.png";